// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"151":"61609d0c","453":"81db3b92","745":"b276b184"}[chunkId] + ".chunk.js";
};